jQuery( '.topImage' ).slick( {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    autoPlay: false,
    asNavFor: '.topImageNav'
} );
jQuery( '.topImageNav' ).slick( {
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.topImage',
    autoPlay: false,
    dots: false,
    fade: false,
    arrows: true,
    centerMode: true,
    centerPadding: 0,
    prevArrow: '<svg class="slick-arrow slick-prev" width="16" height="26" viewBox="0 0 16 26" xmlns="http://www.w3.org/2000/svg"><path d="m3 3 10 10L3 23" stroke="#009CD8" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    nextArrow: '<svg class="slick-arrow slick-next" width="16" height="26" viewBox="0 0 16 26" xmlns="http://www.w3.org/2000/svg"><path stroke="#009CD8" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" d="m3 3 10 10L3 23"/></svg>',
} );

jQuery( '.service-card-slider-4' ).slick( {
    dots: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoPlay: true,
    autoplaySpeed: 2500,
    arrows: false,
    prevArrow: '<svg class="slick-arrow slick-prev" width="16" height="26" viewBox="0 0 16 26" xmlns="http://www.w3.org/2000/svg"><path d="m3 3 10 10L3 23" stroke="#009CD8" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    nextArrow: '<svg class="slick-arrow slick-next" width="16" height="26" viewBox="0 0 16 26" xmlns="http://www.w3.org/2000/svg"><path stroke="#009CD8" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" d="m3 3 10 10L3 23"/></svg>',
    responsive: [
        {
            breakpoint: 769,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 639,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }
    ]
} );

jQuery( '.testimonials-slider' ).slick( {
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    dots: false,
    fade: true,
} );

jQuery( '.blog-slider' ).slick( {
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
    dots: false,
    fade: false,
    prevArrow: '<svg class="slick-arrow slick-prev" width="16" height="26" viewBox="0 0 16 26" xmlns="http://www.w3.org/2000/svg"><path d="m3 3 10 10L3 23" stroke="#009CD8" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    nextArrow: '<svg class="slick-arrow slick-next" width="16" height="26" viewBox="0 0 16 26" xmlns="http://www.w3.org/2000/svg"><path stroke="#009CD8" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" d="m3 3 10 10L3 23"/></svg>',
} );

jQuery( '.main-slide' ).slick( {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    autoPlay: false,
    asNavFor: '.nav-slide'
} );
jQuery( '.nav-slide' ).slick( {
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.main-slide',
    autoPlay: true,
    dots: false,
    fade: false,
    arrows: true,
    centerMode: true,
    centerPadding: 0,
    prevArrow: '<svg class="slick-arrow slick-prev" width="16" height="26" viewBox="0 0 16 26" xmlns="http://www.w3.org/2000/svg"><path d="m3 3 10 10L3 23" stroke="#009CD8" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    nextArrow: '<svg class="slick-arrow slick-next" width="16" height="26" viewBox="0 0 16 26" xmlns="http://www.w3.org/2000/svg"><path stroke="#009CD8" stroke-width="4" fill="none" stroke-linecap="round" stroke-linejoin="round" d="m3 3 10 10L3 23"/></svg>',
} );


// Initialise mobile slick sliders
jQuery( function() {
    const process = jQuery( '.process-steps' );
    const accreds = jQuery( '.accreditations' );
    const mediaQueryList = window.matchMedia( "(max-width: 725px)" );
    const mediaHandler = () => {
        const isSlicked = process.hasClass( 'slick-slider' ) && accreds.hasClass( 'slick-slider' );
        if ( mediaQueryList.matches && !isSlicked ) {
            jQuery( '.our-process .process-arrow' ).css( 'display', 'none' );
            process.slick( {
                slide: '.process-step',
                infinite: false,
                nextArrow: '<svg class="next" width="20" height="20" viewBox="0 0 6 11" xmlns="http://www.w3.org/2000/svg"><path stroke="#5BB94A" fill="none" d="m.5.5 5 5-5 5"/></svg>',
                prevArrow: '<svg class="prev" width="20" height="20" viewBox="0 0 6 11" xmlns="http://www.w3.org/2000/svg"><path stroke="#5BB94A" fill="none" d="m5.5 10.5-5-5 5-5"/></svg>',
            } );
            accreds.slick( {
                autoplay: true,
                autoplaySpeed: 0,
                speed: 5000,
                cssEase: "linear",
                centerMode: true,
                variableWidth: true,
                arrows: false,
            } );
        } else if ( isSlicked ) {
            process.slick( "unslick" );
            accreds.slick( "unslick" );
        }
    };
    mediaHandler();
    mediaQueryList.addEventListener( 'change', mediaHandler );
} );